import { SET_LOADER } from './types';

const initialState = {
  show: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER: {
      return { ...state, show: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
